import { render, staticRenderFns } from "./MessageFilter.vue?vue&type=template&id=26585426&scoped=true&"
import script from "./MessageFilter.vue?vue&type=script&lang=js&"
export * from "./MessageFilter.vue?vue&type=script&lang=js&"
import style0 from "./MessageFilter.vue?vue&type=style&index=0&id=26585426&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26585426",
  null
  
)

export default component.exports